import loadImage from 'blueimp-load-image'
import 'blueimp-canvas-to-blob' // Polyfill
import heic2any from 'heic2any'
import { isNaN } from 'lodash'

// Arguments: File file
// Returns: object of metas informations
// https://github.com/blueimp/JavaScript-Load-Image#meta-data-parsing
export async function metas({file}) {

  return new Promise((resolve, reject) => {
    try {
      loadImage.parseMetaData(file, (data) => {
        const exif = data.exif ? data.exif.getAll() : []
        let orientation, location, datetime

        if( data.exif ) {
          // exif.Orientation is a string, loadImage expects a number
          orientation = data.exif[274]
        }

        if( exif.GPSLatitude && exif.GPSLongitude ) {
          location = {
            latitude: exif.GPSLatitude,
            latitudeRef: exif.GPSLatitudeRef,
            longitude: exif.GPSLongitude,
            longitudeRef: exif.GPSLongitudeRef
          }
        }

        if( exif.DateTimeDigitized ) {
          // Convert date to correct JS format
          const values = exif.DateTimeDigitized.split(/[-: ]+/)
          values[1] -= 1 // Month starts at 1
          datetime = new Date(...values)
        } else if( file.lastModified ) {
          datetime = new Date(file.lastModified)
        }

        if(!datetime || (datetime && isNaN(datetime.getTime()))) {
          datetime = new Date()
        }

        resolve({
          location,
          datetime,
          orientation
        })
      })
    } catch(error) {
      reject(error)
    }
  })
}

// Arguments: File file, Object options
// Returns: canvas
// https://github.com/blueimp/JavaScript-Load-Image#options
export async function resize({file, opts}) {

  const options = {
    orientation: 1,
    canvas: true,
    meta: true,
    ...opts
  }

  return new Promise((resolve, reject) => {
    try {
      loadImage(file, (canvas) => {
        if (canvas instanceof HTMLCanvasElement) {
          resolve(canvas)
        } else {
          resolve(resizeHeic({file, options}))
        }
      }, options)
    } catch(error) {
      reject(error)
    }
  })
}

async function resizeHeic({file, options}) {
  const convertedFile = await heic2any({
    blob: file,
    toType: 'image/jpeg'
  })

  return resize({file: convertedFile, opts: options})
}

// Arguments: Canvas element, Object options
// Returns: Blob
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
export async function convert({canvas, opts = {}}) {

  const options = {
    compression: 0.85,
    format: 'image/jpeg',
    ...opts
  }

  return new Promise((resolve, reject) => {
    try {
      canvas.toBlob((blob) => {
        resolve(blob)
      }, options.format, options.compression)
    } catch(error) {
      reject(error)
    }
  })
}

// Arguments: File/Blob file
// Returns: String base64 encoded image
// https://developer.mozilla.org/fr/docs/Web/API/FileReader/readAsDataURL
export async function fileToDataURI(file) {

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = e => resolve(e.target.result)
    reader.onerror = e => reject(e.target.error)
    reader.readAsDataURL(file)
  })
}

// Arguments: String(base64) dataURI
// Returns: Blob
// https://stackoverflow.com/a/7261048/758728
export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1])

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split('')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ab], {type: mimeString})
}

